module.exports = __webpack_public_path__ + "static/media/schema.8057c977.png";